import { BaseRouteService } from 'core/services';

class PickingBatchRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'picking-batches/';
	}

	create(sourceOfChange) {
		return super.create(this.base + '?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed}', id, options);
	}

	reprintLabels(id) {
		return super.get(this.base + 'reprint/{id}', id);
	}

	exportPickingBatch(id) {
		return super.get(this.base + 'export/{id}', id);
	}

	generatePdf(id) {
		return super.get(this.base + 'generate/{id}', id);
	}

	resendToWms(id) {
		return super.get(this.base + 'resendToWms/{id}', id);
	}
}

export default PickingBatchRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/PickingBatchRouteService.js